import * as React from 'react';
import type { Trip } from 'contracts/tracking-v2/trips';
import { Card, CardContent } from 'components/ui/card';
import { Skeleton } from 'components/ui/skeleton';

import { InvoiceListItemHeader } from './invoice-list-item-header';
import { InvoiceQuickInfo } from './invoice-quick-info';
import { ToggleInvoiceItemsButton } from './toggle-invoice-items-button';
import { InvoiceItems } from './invoice-items';

type Props = React.ComponentProps<typeof Card> & {
  invoice: Trip['invoices'][number];
};

export const InvoiceIListItem = ({ invoice, ...props }: Props) => {
  const [itemsListOpen, setItemsListOpen] = React.useState(false);

  const toggleOpen = () => {
    return setItemsListOpen(!itemsListOpen);
  };

  return (
    <Card {...props}>
      <InvoiceListItemHeader invoice={invoice} />
      <CardContent>
        <InvoiceQuickInfo invoice={invoice} className={'mb-6'} />
        <ToggleInvoiceItemsButton isOpen={itemsListOpen} onClick={toggleOpen} />
        {itemsListOpen && (
          <InvoiceItems items={invoice.items} className={'mt-6'} />
        )}
      </CardContent>
    </Card>
  );
};

export const InvoiceListItemSkeleton = (props: React.ComponentProps<typeof Card>) => {
  return (
    <Card {...props}>
      <CardContent className={'pt-6'}>
        <div className={'flex items-center gap-4'}>
          <Skeleton className={'w-40 h-10'} />
          <Skeleton className={'w-80 h-10'} />
          <Skeleton className={'w-40 h-10 ml-auto'} />
          <Skeleton className={'w-20 h-10'} />
        </div>
        <Skeleton className={'mt-6 w-full h-20'} />
        <Skeleton className={'mt-6 w-40 h-10'} />
      </CardContent>
    </Card>
  );
};
